import React, { useState } from "react";

import { useHistory } from "react-router-dom";

import DevForgotPassword from "../../../../../../presentation/pages/auth/developer/forgot-password";

import Authentication from "../../../../../../infra/cognito/authentication";
import { t } from "../../../../../../presentation/adapters/translate/translate";

const MakeDevForgotPassword: React.FC = () => {
  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState<string | null>("");

  const handleSubmit = async (values: any): Promise<void> => {
    try {
      await Authentication.forgotPassword(values.email);
      localStorage.setItem("recoveryEmail", values.email);
      history.push("/developer/recovery-password");
    } catch (error: any) {
      setErrorMessage(t(error.code, error.message));
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
    }
  };

  const dataForm = [
    {
      items: [
        {
          component: "Input",
          name: "email",
          title: "E-mail",
          label: "E-mail",
          value: "",
          validations: "inputRequired",
        },
        {
          name: "button",
          component: "Button",
          title: "Enviar",
          submittingText: "Enviando...",
        },
      ],
    },
  ];

  const props = {
    onSubmit: handleSubmit,
    dataForm,
    errorMessage,
  };

  return <DevForgotPassword {...props} />;
};

export default MakeDevForgotPassword;
